import { Component } from './component';

export interface FieldRowProps {
  stacked?: boolean;
}

export class FieldRow extends Component {
  public el: HTMLDivElement;

  constructor(props?: FieldRowProps) {
    super();
    this.el = document.createElement('div');
    this.el.classList.add(props?.stacked ? 'field-row-stacked' : 'field-row');
  }
}
